import { useMemo } from 'react';

// material-ui
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

// project imports
import MainCard from 'components/MainCard';
import SimpleBar from 'components/third-party/SimpleBar';
import CircularWithPath from 'components/@extended/progress/CircularWithPath';

// types
import { Role } from 'types/userrole';
import RoleForm from './RoleForm';

interface Props {
    open: boolean;
    modalToggler: () => void;
    role?: Role | null;
    onRoleCreated?: (newRole: Role) => void;
}


export default function RoleModal({ open, modalToggler, role, onRoleCreated }: Props) {
    const loading = false;

    const roleForm = useMemo(
        () => !loading && <RoleForm role={role || null} closeModal={modalToggler} onRoleCreated={onRoleCreated} />,
        [role, loading, onRoleCreated]
    );

    return (
        <>
            {open && (
                <Modal
                    open={open}
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
                        modalToggler();
                    }}
                    aria-labelledby="modal-role-add-label"
                    aria-describedby="modal-role-add-description"
                    sx={{
                        '& .MuiPaper-root:focus': {
                            outline: 'none'
                        }
                    }}
                >
                    <MainCard
                        sx={{ minWidth: { xs: 320, sm: 600, md: 768 }, maxWidth: 768, height: 'auto', maxHeight: 'calc(100vh - 48px)' }}
                        modal
                        content={false}
                    >
                        <SimpleBar sx={{ maxHeight: `calc(100vh - 48px)`, '& .simplebar-content': { display: 'flex', flexDirection: 'column' } }}>
                            {loading ? (
                                <Box sx={{ p: 5 }}>
                                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                                        <CircularWithPath />
                                    </Stack>
                                </Box>
                            ) : (
                                roleForm
                            )}
                        </SimpleBar>
                    </MainCard>
                </Modal>
            )}
        </>
    );
}
